const props = {
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  fill: 'none',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
}

export const IconePhotos = () => (
  <svg {...props} aria-hidden="true">
    <rect x="3" y="6" width="18" height="14" rx="2" />
    <circle cx="12" cy="13" r="3.4" />
    <path d="M8 6l1.5-2h5L16 6" />
  </svg>
)

export const IconePlans = () => (
  <svg {...props} aria-hidden="true">
    <path d="M4 5h16v14H4z" />
    <path d="M9 5v14M4 12h5" />
  </svg>
)

export const IconeDevis = () => (
  <svg {...props} aria-hidden="true">
    <path d="M6 3h9l3 3v15H6z" />
    <path d="M9 9h6M9 13h6M9 17h4" />
  </svg>
)

export const IconeSuivis = () => (
  <svg {...props} aria-hidden="true">
    <path d="M4 6h16M4 12h16M4 18h10" />
    <path d="M17 17l2 2 3-4" />
  </svg>
)

export const IconeInfo = () => (
  <svg {...props} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v6M12 8h.01" />
  </svg>
)

export const LogoLarente = () => (
  // Icône officielle (géométrie tirée du fichier logo vectoriel Isolation Larente)
  <svg width="40" height="40" viewBox="8.654 120.754 57.292 57.292" aria-hidden="true">
    <g transform="matrix(1 0 0 -1 0 299)">
      <path transform="translate(0 0)" d="M15.01 154.607 L25.507 172.385 C25.507 172.385 27.543 175.287 29.515 172.462 C31.004 170.163 40.852 153.373 40.852 153.373 C40.852 153.373 42.226 149.187 40.165 145.57 C38.104 141.953 30.088 128.236 30.088 128.236 C30.088 128.236 27.645 123.936 25.202 128.16 C22.759 132.385 15.201 145.125 15.201 145.125 C15.201 145.125 12.148 149.842 15.01 154.607 Z" fill="#FFCA00" stroke="#000" strokeWidth="2.859" />
      <path transform="translate(10.29 0)" d="M15.01 154.607 L25.507 172.385 C25.507 172.385 27.543 175.287 29.515 172.462 C31.004 170.163 40.852 153.373 40.852 153.373 C40.852 153.373 42.226 149.187 40.165 145.57 C38.104 141.953 30.088 128.236 30.088 128.236 C30.088 128.236 27.645 123.936 25.202 128.16 C22.759 132.385 15.201 145.125 15.201 145.125 C15.201 145.125 12.148 149.842 15.01 154.607 Z" fill="#FFCA00" stroke="#000" strokeWidth="2.859" />
      <path transform="translate(20.258 0)" d="M15.01 154.607 L25.507 172.385 C25.507 172.385 27.543 175.287 29.515 172.462 C31.004 170.163 40.852 153.373 40.852 153.373 C40.852 153.373 42.226 149.187 40.165 145.57 C38.104 141.953 30.088 128.236 30.088 128.236 C30.088 128.236 27.645 123.936 25.202 128.16 C22.759 132.385 15.201 145.125 15.201 145.125 C15.201 145.125 12.148 149.842 15.01 154.607 Z" fill="#FFCA00" stroke="#000" strokeWidth="2.859" />
    </g>
  </svg>
)

/**
 * Logo officiel complet (icône à gauche, nom à droite), tiré du fichier
 * « Logo sets - Isolation Larente_5.pdf ». Version texte blanc en mode sombre.
 */
export const LogoComplet = ({ hauteur = 40 }: { hauteur?: number }) => (
  <picture style={{ display: 'block', lineHeight: 0 }}>
    <source srcSet="/logo-horizontal-sombre.svg" media="(prefers-color-scheme: dark)" />
    <img src="/logo-horizontal.svg" alt="Isolation Larente" style={{ height: hauteur, width: 'auto' }} />
  </picture>
)
